module.exports = __webpack_public_path__ + "static/media/1_en.ae2ceb38.png";